import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import { DIGO_SERVICES, workerCategorySearchLinkProps } from '../digoServices';

// Reuse the browse-services card styling for visual consistency.
import css from './SectionBrowseServicesDigo.module.css';

const WorkerCategoryCard = ({ service }) => {
  const linkProps = workerCategorySearchLinkProps(service.id);
  return (
    <NamedLink name={linkProps.name} to={linkProps.to} className={css.card}>
      <img src={service.photo} alt="" className={css.photo} loading="lazy" />
      <div className={css.text}>
        <div className={css.label}>{service.label}</div>
        <div className={css.sub}>{service.sub}</div>
      </div>
    </NamedLink>
  );
};

/**
 * Discovery grid for logged-in clients: browse the workers offering each
 * service category. Each card opens the worker search filtered to that
 * category (sell-services listings), answering "je veux voir les travailleurs".
 */
const SectionBrowseWorkersDigo = () => {
  return (
    <section className={css.root}>
      <div className={css.container}>
        <h2 className={css.title}>
          <FormattedMessage id="SectionBrowseWorkersDigo.title" />
        </h2>
        <p className={css.subtitle}>
          <FormattedMessage id="SectionBrowseWorkersDigo.subtitle" />
        </p>
        <div className={css.grid}>
          {DIGO_SERVICES.map(service => (
            <WorkerCategoryCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionBrowseWorkersDigo;
